import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

import _ from 'lodash';
import { observer } from 'mobx-react';
import { FormGroup, Label, Input, Button, DefaultSheet, SheetBody, SheetFooter } from 'twyne-new.ui';

import SelectTimeZone from 'components/form/SelectTimeZoneInput';
import appStore from 'stores/app';

const propTypes = {
  isOpen: PropTypes.bool,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  search: PropTypes.string,
  onChangeSearch: PropTypes.func,
  params: PropTypes.object,
};

@observer
class ReportsProgressionFilter extends React.Component {
  state = {
    params: {},
  }

  componentWillMount() {
    this.setState({ params: _.cloneDeep(this.props.params) });
  }

  handleChange = (property, value) => {
    const { params } = this.state;
    params[property] = value;
    this.setState({ params });
  }

  handleChangeSite = value => {
    const { params } = this.state;
    params.siteId = value;
    this.setState({ params });
  }

  siteOptions = () => {
    const opts = appStore.sites.map(site => ({ value: site.id, label: site.name }));

    return opts;
  }

  render() {
    if (!this.props.isOpen) {
      return null;
    }

    return (

      <DefaultSheet
        title="Filter"
        wrapperProps={{ defaultOpen: true, open: true, onOpenChange: this.props.onClose }}
      >
        <SheetBody>
          <FormGroup>
            <Label>Search</Label>
            <Input placeholder="Search..." value={this.props.search}
              onChange={e => this.props.onChangeSearch(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Site</Label>
            <Select
              options={this.siteOptions()}
              name="siteId"
              placeholder="Select site"
              value={this.state.params.siteId}
              onChange={opt => this.handleChangeSite(opt ? opt.value : null)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Pid</Label>
            <Input placeholder="Pid..." value={this.state.params.pid}
              onChange={e => this.handleChange('pid', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Timezone</Label>
            <SelectTimeZone
              value={this.state.params.timeZone}
              onChange={opt => this.handleChange('timeZone', opt ? opt.value : null)}
              placeholder="Organizations timezone"
            />
          </FormGroup>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.props.onClose} variant='ghost'>Cancel</Button>
          <Button onClick={() => this.props.onApply(this.state.params)} color="accent">Apply</Button>
        </SheetFooter>
      </DefaultSheet>
    );
  }
}

ReportsProgressionFilter.propTypes = propTypes;

export default ReportsProgressionFilter;
